@file:OptIn(InternalResourceApi::class)

package dentalcrm.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/dentalcrm.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_365_796_751)
internal val Res.drawable.ic_cyclone: DrawableResource by lazy {
      DrawableResource("drawable:ic_cyclone", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cyclone.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-873_566_858)
internal val Res.drawable.ic_dark_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dark_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-990_425_980)
internal val Res.drawable.ic_light_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_light_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_light_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(823_283_672)
internal val Res.drawable.ic_rotate_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_rotate_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_rotate_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_671_458_194)
internal val Res.drawable.img_error: DrawableResource by lazy {
      DrawableResource("drawable:img_error", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/img_error.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/img_error.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_error.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_error.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_error.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(997_301_638)
internal val Res.drawable.img_success: DrawableResource by lazy {
      DrawableResource("drawable:img_success", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/img_success.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/img_success.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_success.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_success.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_success.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(391_983_553)
internal val Res.drawable.img_warning: DrawableResource by lazy {
      DrawableResource("drawable:img_warning", setOf(
        ResourceItem(setOf(DensityQualifier.HDPI, ), "${MD}drawable-hdpi/img_warning.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.MDPI, ), "${MD}drawable-mdpi/img_warning.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_warning.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_warning.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_warning.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_cyclone", Res.drawable.ic_cyclone)
  map.put("ic_dark_mode", Res.drawable.ic_dark_mode)
  map.put("ic_light_mode", Res.drawable.ic_light_mode)
  map.put("ic_rotate_right", Res.drawable.ic_rotate_right)
  map.put("img_error", Res.drawable.img_error)
  map.put("img_success", Res.drawable.img_success)
  map.put("img_warning", Res.drawable.img_warning)
}
